import * as React from "react"
import { Container } from "react-bootstrap"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import {
    ImageList,
    ImageListItem,
    ImageListItemBar,
} from "@mui/material"

import Layout from "../../components/layout"
import Seo from "../../components/seo"
import "bootstrap/dist/css/bootstrap.min.css"

const IndexPage = ({location}) => {
  return (
    <Layout location={location}>
      <Seo title="Index page for places" />
      <Container>
        <h1>Index: Overview</h1>
        <p>
        In this section, we compiled indexes of all Singapore places of worship which Dr Ho Chee Lick has
        comprehensively documented in his artwork. The indexes are based on the categories of&nbsp;
        <Link to="/data-index/chinese-temples">
          Chinese Temples
        </Link>
        ,&nbsp;
        <Link to="/data-index/churches">
          Churches
        </Link>
        ,&nbsp;
        <Link to="/data-index/hindu-temples">
          Hindu Temples
        </Link>
        ,&nbsp;
        <Link to="/data-index/islamic-mosques">
          Islamic Mosques 
        </Link>
        ,&nbsp;
        <Link to="/data-index/sikh-temples">
          Sikh Temples
        </Link>
        &nbsp;and&nbsp;
        <Link to="/data-index/other-temples">
          others
        </Link>
        . The indexes are sorted by their names in alphabetical order, and contain other information such as original or alternate names and addresses.
        </p>

        <ImageList variant="standard" cols={3} gap={8}>
          <ImageListItem>
            <Link to="/data-index/chinese-temples">
              <StaticImage src="../../images/Cropped-Images/R1-065.jpg" alt="Chinese Temple" />
              <ImageListItemBar title="Chinese Temples"></ImageListItemBar>
            </Link>
          </ImageListItem>
          
          <ImageListItem>
            <Link to="/data-index/churches">
              <StaticImage src="../../images/Cropped-Images/R5-046.jpg" alt="Churches" />
              <ImageListItemBar title="Churches"></ImageListItemBar>
            </Link>
          </ImageListItem>

          <ImageListItem>
            <Link to="/data-index/hindu-temples">
              <StaticImage src="../../images/Cropped-Images/R3-001.jpg" alt="Hindu Temple" />
              <ImageListItemBar title="Hindu Temples"></ImageListItemBar>
            </Link>
          </ImageListItem>

          <ImageListItem>
            <Link to="/data-index/islamic-mosques">
              <StaticImage src="../../images/Cropped-Images/R2-001.jpg" alt="Islamic Mosques" />
              <ImageListItemBar title="Islamic Mosques"></ImageListItemBar>
            </Link>
          </ImageListItem>

          <ImageListItem>
            <Link to="/data-index/sikh-temples">
              <StaticImage src="../../images/Cropped-Images/R4-003.jpg" alt="Sikh Temple" />
              <ImageListItemBar title="Sikh Temples"></ImageListItemBar>
            </Link>
          </ImageListItem>
          
          
          <ImageListItem>
            <Link to="/data-index/other-temples">
              <StaticImage src="../../images/Cropped-Images/R6-001.jpg" alt="Others" />
              <ImageListItemBar title="Others"></ImageListItemBar>
            </Link>
          </ImageListItem>
        </ImageList>
      </Container>

    </Layout>
  )
}

export default IndexPage
